module.exports = __webpack_public_path__ + "banquet/components/images/chevron_white.991e7f7ec48cd7b4e8ed95e769ce3e99.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/chevron_white.png
// module id = 1704
// module chunks = 1